const DEFAULT_MAX_VALUE = 99.99;

export default function isValidPercentage(
  value: string,
  maxValue: number = DEFAULT_MAX_VALUE,
) {
  // early return if value has more than 2 decimal places
  if (value.split(".")?.length > 2) return false;

  let numberValue = parseFloat(value);
  // check if value ends with decimal point
  if (value.endsWith(".")) {
    // if it does, grab the value before the decimal point
    const valueBeforeDecimal = value.slice(0, -1);
    numberValue = parseFloat(valueBeforeDecimal);
  }
  // check if value is a number and less than max value
  return !isNaN(numberValue) && numberValue <= maxValue;
}
